<template>
	<div class="banner" :class="path_list.indexOf(path)!=-1?'on':''">
		<div v-if="path=='index'||path==''">
			<video src="https://api.bccsc.com.cn/uploads/mp4/index_bg.mp4?1" v-show="video==1" poster="@/assets/img/index_bg.png" loop="loop" muted autoplay class="w100">您的浏览器不支持 video 标签。</video>
			<video src="https://api.bccsc.com.cn/uploads/mp4/index_bg1.mp4?1" v-show="video==2" poster="@/assets/img/index_bg.png" loop="loop" muted autoplay class="w100 ">您的浏览器不支持 video 标签。</video>
		</div>
		<video v-else-if="path=='bccsc'" src="https://api.bccsc.com.cn/uploads/mp4/index_bg.mp4?1" poster="@/assets/img/index_bg.png" loop="loop" muted autoplay class="w100">您的浏览器不支持 video 标签。</video>
		<video v-else-if="path=='bcs'" src="https://api.bccsc.com.cn/uploads/mp4/index_bg1.mp4?1" poster="@/assets/img/index_bg.png" loop="loop" muted autoplay class="w100 ">您的浏览器不支持 video 标签。</video>
		<img v-else :src="banner_bg" class="w100" alt="">
		<div class="banner_absolute">
			<div class="middle">
				<div class="name" :class="video==1?'on':''" @mouseenter="(e)=>{xuesheng_mouseenter(e,'xuesheng1'),video=1}" @mouseleave="(e)=>{xuesheng_mouseleave(e,'xuesheng1')}" ref="xuesheng1" @click="click_banner('left')">
					<div class="span_span" v-html="left"></div>
				</div>
				<!-- :class="path_list.indexOf(path)!=-1?'':'wow flipInX'" -->
				<img v-if="center_img" :src="center_img" class="center_img"  data-wow-delay="0.5s" data-wow-duration="1s" alt="" @mouseenter="(e)=>{xuesheng_mouseenter(e,'xuesheng0')}" @mouseleave="(e)=>{xuesheng_mouseleave(e,'xuesheng0')}" ref="xuesheng0">
				<div class="name" :class="video==2?'on':''" @mouseenter="(e)=>{xuesheng_mouseenter(e,'xuesheng2'),video=2}" @mouseleave="(e)=>{xuesheng_mouseleave(e,'xuesheng2')}" ref="xuesheng2" @click="click_banner('right')">
					<div class="span_span" v-html="right"></div>
				</div>
			</div>
			<div class="follow" v-if="path_list.indexOf(path)!=-1">
				<div class="wrap">
					<div class="name" @click="router_url('/tansuo')" style="cursor: pointer;">{{$t('关注&探索')}}</div>
					<div class="heng"></div>
					<div class="imgs">
						<img src="@/assets/img/weixin.png" class="img" alt="">
						<div class="tanchu">
							<div class="tit">{{$t('扫码关注我们的公众号')}}</div>
							<div class="ul_img">
								<div class="ul_img_li">
									<img src="@/assets/img/weixin_erweim1.png" class="erwei" alt="">
									<div class="p1">{{$t('北京中加学校')}}</div>
								</div>
								<div class="ul_img_li">
									<img src="@/assets/img/weixin_erweim2.png" class="erwei" alt="">
									<div class="p1">{{$t('北京通州华仁学校')}}</div>
								</div>
							</div>
						</div>
					</div>
					<div class="imgs">
						<img src="@/assets/img/weiqq.png" class="img" alt="">
						<div class="tanchu">
							<div class="tit">{{$t('扫码关注视频号')}}</div>
							<div class="ul_img">
								<div class="ul_img_li">
									<img src="@/assets/img/weixin_erweim3.png" class="erwei" alt="">
								</div>
							</div>
						</div>
					</div>
					<div class="imgs">
						<img src="@/assets/img/xiaohongshu.png" class="img" alt="">
						<div class="tanchu">
							<div class="tit">{{$t('扫码在小红书里找到我们')}}</div>
							<div class="ul_img">
								<div class="ul_img_li">
									<img src="@/assets/img/weixin_erweim4.png" class="erwei" alt="">
								</div>
							</div>
						</div>
					</div>
					<div class="li">{{$t('家长平台')}}</div>
					<div class="li">{{$t('学生系统')}}</div>
					<div class="li">{{$t('STAFF')}}</div>
				</div>
			</div>
			<div class="enroll" :class="$i18n.locale">
				<object v-if="is_object()" :data="enroll_img" class="img" type="image/svg+xml"></object>
				<img v-else :src="enroll_img" class="img" alt="">
				<div class="name">{{$t('招生咨询')}}</div>
				<div class="com">
					<div>{{$t('我们会认真评估每一份申请。')}}</div>
					<div>{{$t('在接下来的几个月中，我们期待能更好地了解申请人及其家庭。')}}</div>
				</div>
				<div class="zuxun" @click="is_pingbic=true">{{$t('立即咨询')}}</div>
			</div>
		</div>
		<!-- 招生咨询 -->
		<zhaoshengzixun :is_pingbic="is_pingbic" @callback="()=>{is_pingbic=false}"></zhaoshengzixun>
	</div>
</template>
<script>
import zhaoshengzixun from '@/components/views/zhaoshengzixun'
import {TweenMax} from 'gsap';
export default {
	name: 'banner',
	components:{
		zhaoshengzixun
	},
	props: {
		left: {
			type: String,
			default:''
		},
		right: {
			type: String,
			default:''
		},
		banner_bg: {
			type: String,
			default:''
		},
		center_img:{
			type: String,
			default:''
		},
		enroll_img:{
			type: String,
			default:''
		}
	},
	data(){
		return{
			path_list:['','index','bccsc','bcs'],
			path:'',
			is_pingbic:false,
			video:1,
		}
	},
	mounted(){
		this.path = this.$route.path.replace('/', '');
		// console.log(this.path)
	},
	methods:{
		click_banner(name){
			this.$emit('callback',name);
		},
		is_object(){
			var arr = this.enroll_img.split('.');
			if(arr[arr.length-1]=='svg'){
				return true;
			}
			return false;
		},
		xuesheng_mouseenter(e,name){
			const target = e.target; // 获取触发事件的 DOM 元素
			const rect = e.target.getBoundingClientRect();
            var a = e.clientX - rect.left - rect.width / 2;
            var o = e.clientY - rect.top - rect.height / 2;
			var div = this.$refs[name];
			TweenMax.to(div, 0.5, { x: a * .1, y: o * .1 })
		},
		xuesheng_mouseleave(e,name){
			var div = this.$refs[name];
            TweenMax.to(div, .5, { y: "0px", x: "0px" });
		},
	}
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/views/banner.vue